var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contactum-fields" }, [
    _c("a", { staticClass: "btn-image", attrs: { href: "#" } }, [
      _vm._v(_vm._s("Select Files"))
    ]),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", {
          staticClass: "help",
          domProps: { innerHTML: _vm._s(_vm.field.help) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }